/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import Icon from '@ant-design/icons';

function EmailSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="69"
      viewBox="0 0 71 69"
      fill="none"
    >
      <g clipPath="url(#clip0_113_17478)">
        <path
          d="M7.24984 26.3333L35.5832 44.0416L63.9165 26.3333L35.5832 8.62494L7.24984 26.3333ZM70.9998 26.3333V61.7499C70.9998 63.6286 70.2536 65.4302 68.9252 66.7586C67.5968 68.087 65.7951 68.8333 63.9165 68.8333H7.24984C5.37122 68.8333 3.56955 68.087 2.24116 66.7586C0.912781 65.4302 0.166504 63.6286 0.166504 61.7499V26.3333C0.166504 23.7479 1.54775 21.5166 3.60192 20.277L35.5832 0.266602L67.5644 20.277C69.6186 21.5166 70.9998 23.7479 70.9998 26.3333Z"
          fill="#721EFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_113_17478">
          <rect width="71" height="69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function EmailIcon(props: { style?: React.CSSProperties }) {
  return <Icon component={EmailSvg} {...props} />;
}
